import './index.css';
import { jsx } from 'react/jsx-runtime';
import { memo, isValidElement, Fragment, Children, cloneElement } from 'react';

const CLICK_DISTANCE_THRESHOLD_PX = 24;
const interceptClick = (node) => {
    const props = {};
    if (node.props.onClick) {
        let click = false;
        let coordinates = null;
        props.onClick = () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        props.onPointerDown = (event) => {
            click = true;
            coordinates = { x: event.pageX, y: event.pageY };
            node.props.onPointerDown?.(event);
        };
        props.onPointerCancel = (event) => {
            click = false;
            node.props.onPointerCancel?.(event);
        };
        props.onPointerLeave = (event) => {
            click = false;
            node.props.onPointerLeave?.(event);
        };
        props.onPointerUp = (event) => {
            if (click) {
                if (coordinates !== null &&
                    Math.pow(event.pageX - coordinates.x, 2) + Math.pow(event.pageY - coordinates.y, 2) <=
                        Math.pow(CLICK_DISTANCE_THRESHOLD_PX, 2)) {
                    node.props.onClick?.(event);
                }
                click = false;
                coordinates = null;
            }
            node.props.onPointerUp?.(event);
        };
    }
    return cloneElement(node, props);
};
const applyInterceptor = (node, func) => {
    if (!isValidElement(node)) {
        return jsx(Fragment, { children: node });
    }
    let children;
    ((props) => {
        if (props.children) {
            const childrenArr = Children.toArray(props.children);
            children =
                childrenArr.length === 1
                    ? applyInterceptor(childrenArr[0], func)
                    : childrenArr.map((child) => applyInterceptor(child, func));
        }
    })(node.props);
    return cloneElement(func(node), {}, children);
};
const ClickInterceptor = memo(({ children }) => {
    return applyInterceptor(children, interceptClick);
});
ClickInterceptor.displayName = 'ClickInterceptor';

export { ClickInterceptor };
//# sourceMappingURL=ClickInterceptor.js.map
